import React from "react"
import { Disclosure } from "@headlessui/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

export default function Accordion(props) {
  return (
    <div className="p-2 mx-auto rounded-xl">
        <Disclosure>
            {({ open }) => (
            <>
                <Disclosure.Button className="flex items-center w-full px-6 py-4 font-medium text-left bg-ia-blue-light rounded-lg hover:bg-blue-gray-200 focus:outline-none">
                <FontAwesomeIcon icon={ open ? faMinus : faPlus } className="w-5 h-5 mr-3" />
                <span>{props.title}</span>
                </Disclosure.Button>
                <Disclosure.Panel className="px-6 pt-4 pb-2">
                    <div dangerouslySetInnerHTML={ { __html: props.children } }></div>
                </Disclosure.Panel>
            </>
            )}
        </Disclosure>
    </div>
  );
}
